if (typeof ReadMoreLess !== 'function') {
	class ReadMoreLess extends HTMLElement {
		constructor() {
			super();
			this.onToggle = this.onToggle.bind(this);
			this.onResize = this.onResize.bind(this);
			this.initialized = false;
		}

		connectedCallback() {
			this.init();
		}

		disconnectedCallback() {
			if (this.toggleButton) {
				this.toggleButton.removeEventListener('click', this.onToggle);
			}
			window.removeEventListener('resize', this.onResize);
			this.initialized = false;
		}

		init() {
			if (this.initialized) return;

			this.content = this.querySelector('.read-more__content');
			this.toggleButton = this.querySelector('.read-more__toggle');

			if (!this.content || !this.toggleButton) return;

			const lines = parseInt(this.dataset.lines || '6', 10);
			this.readMoreText = this.dataset.readMore || this.toggleButton.textContent.trim();
			this.readLessText = this.dataset.readLess || this.toggleButton.textContent.trim();

			if (!Number.isNaN(lines)) {
				this.style.setProperty('--read-more-lines', `${lines}`);
				this.lines = lines;
			} else {
				this.lines = 6;
			}

			if (!this.content.id) {
				this.content.id = `ReadMore-${Math.floor(Math.random() * 100000)}`;
			}
			this.toggleButton.setAttribute('aria-controls', this.content.id);

			this.toggleButton.addEventListener('click', this.onToggle);
			window.addEventListener('resize', this.onResize);

			this.initialized = true;
			requestAnimationFrame(() => this.update());
		}

		update() {
			if (!this.content) return;

			const lineHeight = this.getLineHeight();
			const maxHeight = lineHeight > 0 ? lineHeight * this.lines : 0;
			const needsCollapse = maxHeight > 0 && this.content.scrollHeight > maxHeight + 2;

			if (!needsCollapse) {
				this.classList.remove('read-more--collapsible', 'read-more--collapsed', 'read-more--expanded');
				this.toggleButton.setAttribute('aria-expanded', 'false');
				return;
			}

			this.classList.add('read-more--collapsible');

			const isExpanded = this.classList.contains('read-more--expanded');
			this.classList.toggle('read-more--collapsed', !isExpanded);
			this.toggleButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
			this.toggleButton.textContent = isExpanded ? this.readLessText : this.readMoreText;
		}

		onToggle() {
			const isExpanded = !this.classList.contains('read-more--expanded');

			this.classList.toggle('read-more--expanded', isExpanded);
			this.classList.toggle('read-more--collapsed', !isExpanded);
			this.toggleButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
			this.toggleButton.textContent = isExpanded ? this.readLessText : this.readMoreText;
		}

		getLineHeight() {
			const sample = this.content.querySelector(
				'.rich-text__text, .rich-text__title, p, li, h1, h2, h3, h4, h5, h6',
			);
			const target = sample || this.content;
			const computed = window.getComputedStyle(target);
			const lineHeightValue = computed.lineHeight;
			let lineHeight = parseFloat(lineHeightValue || '0');

			if (Number.isNaN(lineHeight) || lineHeightValue === 'normal') {
				const fontSize = parseFloat(computed.fontSize || '0');
				lineHeight = fontSize ? fontSize * 1.2 : 0;
			}

			return lineHeight;
		}

		onResize() {
			this.update();
		}
	}

	if (typeof customElements.get('read-more-less') == 'undefined') {
		customElements.define('read-more-less', ReadMoreLess);
	}

	document.addEventListener('shopify:section:load', (e) => {
		e.target.querySelectorAll('read-more-less').forEach((element) => {
			element.init();
		});
	});
}
